<itl-checkbox [(ngModel)]="value" [title]="node.title" [required]="node.mandatory" [description]="node.description">
</itl-checkbox>
